import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, Table, CardFooter } from "reactstrap";
import { Link } from 'react-router-dom';
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

function ConnectInsuranceService() {

    const [loading, setLoading] = useState(true)
    const [insurance, setInsurance] = useState([])

    const [cancreate, setCancreate]=useState(true)

    const token = useSelector((state) => state.userLogin.userInfo.token);
    
    const is_insurance_profile = useSelector((state) => state.userLogin.userInfo.is_insurance_profile);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/list-synchronization-user/`, config);

                if (response.status===200) {

                    setInsurance(response.data)
                    setCancreate(false)

                } else {

                }
                
            } catch (error) {
                
                console.log(error)

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);
        
    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):( 
                <Container className="mt--15" fluid>
                    <Row>
                        {is_insurance_profile ? (
                            <>
                            </>
                        ):(
                            <>
                                {cancreate ? (
                                    <>

                                    </>
                                ):(
                                    <>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-right mt-5">
                                            <Link to="/damage/">
                                                <Button color="warning" className="ml-auto">
                                                    {t('Report damage')} <i className='fa fa-shield'></i>
                                                </Button>
                                            </Link>
                                        </Col>
                                    </>
                                )}
                            </>
                        )}
                        {is_insurance_profile ? (
                            <>
                            
                            </>
                        ):(
                            <>
                                {cancreate ? (
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-right mt-5">
                                        <Link to="/create-insurance-connection/">
                                            <Button color="success" className="ml-auto">
                                                {t('Add Insurance Connection')} <i class="fa-solid fa-plus"></i>
                                            </Button>
                                        </Link>
                                    </Col>
                                ):null}  
                            </>
                        )}
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            {cancreate === false ? (
                                <>
                                    <Card className="shadow">
                                        <CardHeader className="border-0">
                                            <h3>{t('Agricultural Insurance Linkup')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <h5>{t('Insurance Operator information')}</h5>
                                            <br></br>
                                            <Table
                                                className="align-items-center table-flush"
                                                responsive
                                                >
                                                <thead>
                                                    <tr>
                                                        <th>{t('First Name')}</th>
                                                        <th>{t('Last Name')}</th>
                                                        <th>{t('Email')}</th>
                                                        <th>{t('Accepted the link?')}</th>
                                                        <th>{t('Requested At')}</th> 
                                                        <th>{t('Delete')}</th>                      
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr key={insurance.id}>
                                                        <td>{insurance.first_name_insurance_user}</td>
                                                        <td>{insurance.last_name_insurance_user}</td>
                                                        <td>{insurance.email_insurance_user}</td>
                                                        <td>
                                                            {insurance.is_accepted ? (
                                                                <FaCheckCircle color="green" />
                                                            ) : (
                                                                <FaTimesCircle color="red" />
                                                            )}
                                                        </td>
                                                        <td>{format(new Date(insurance.created_at), 'PPpp')}</td>                                                        
                                                        <td>
                                                            <Link to={`/delete-insurance-connection/${insurance.id}`}>
                                                                <Button color="danger">
                                                                    {t('Delete')} <i className="fas fa-trash"></i>
                                                                </Button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </CardBody>
                                        <CardFooter>
                                            <Row>
                                                <Col>
                                                    <Link to="/">
                                                        <Button color="primary">
                                                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                        </Button>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </CardFooter>
                                    </Card>
                                </>
                            ):(
                                <>
                                    <Card className="shadow">
                                        <CardHeader className="border-0">
                                            <h3>{t('Agricultural Insurance Linkup')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <h4>{t('No Agricultural Insurance Link')}</h4>
                                        </CardBody>
                                        <CardFooter>
                                            <Row>
                                                <Col>
                                                    <Link to="/">
                                                        <Button color="primary">
                                                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                        </Button>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </CardFooter>
                                    </Card>
                                </>        
                            )}
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default ConnectInsuranceService
